function waitForElement(selector, callback) {
  const element = document.querySelector(selector);

  if (element) {
    callback(element);
  } else {
    setTimeout(() => {
      waitForElement(selector, callback);
    }, 500);
  }
}

function enableDisableDropdown() {
  const checkboxSelector = '.gpo-checkbox input[type="checkbox"]';
  const selectLabelSelector = '[data-element-id="select-1"] .gpo-label';
  const selectDropdownSelector = '[data-element-id="select-1"] select';

  waitForElement(checkboxSelector, (checkbox) => {
    waitForElement(selectLabelSelector, (selectLabel) => {
      waitForElement(selectDropdownSelector, (selectDropdown) => {

        selectLabel.classList.add('gpo-select-label');
        selectDropdown.classList.add('gpo-select-dropdown');

        function updateSelectStatus() {
          const isChecked = checkbox.checked;
          selectLabel.classList.toggle('gpo-disabled', !isChecked);
          selectDropdown.disabled = !isChecked;
          // Add this line to toggle the 'gpo-disabled' class for the text inside the label
          selectLabel.querySelector('.label-content').classList.toggle('gpo-disabled', !isChecked);
        }

        checkbox.addEventListener('change', updateSelectStatus);
        updateSelectStatus(); 
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', enableDisableDropdown);
